import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoIosArrowDown } from "react-icons/io";

const PriceServices = () => {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState({
      massage: true,
      cryoMassage: true,
      signaturefacial: true,
      monthlyMembership: true,
      cryoSkinHealth: true,
      cryoslimming: true,
      cryoFacial: true,
      targetedCryotherapy: true,
      eyelashesExtension: true,
    });
    const massages = t('massages', { returnObjects: true });
    const cryoMassage = t('cryoMassage', { returnObjects: true });
    const signaturefacial = t('signaturefacial', { returnObjects: true });
    // const monthlyMembership = t('monthlyMembership', { returnObjects: true });
    const cryoSkinHealth = t('cryoSkinHealth', { returnObjects: true });
    const cryoFacial = t('cryoFacial', { returnObjects: true });
    const cryoslimming = t('cryoslimming', { returnObjects: true });
    const targetedCryotherapy = t('targetedCryotherapy', { returnObjects: true });
    const eyelashesExtension = t("eyelashesExtension", {
      returnObjects: true,
    });

    const handleServices = (event) =>{
      setIsOpen((prevState) => ({
        ...prevState,
        [event]: !prevState[event]
    }));
    }

  return (
    <div className="container mx-auto mt-20 py-5  p-6">
      <h1 className="text-center text-4xl font-semibold font-Merriweather">
        {t("artistrySpawellness")}
      </h1>
      <h1 className="text-3xl font-Merriweather border-b py-4">
        {t("priceList")}
      </h1>

      {/* massage services */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("massage")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">{t("type")}</h1>
          <p className="text-sm">{t("typeDesc")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`$.'assage' ? 'rotate-180' : 'rotate-0'} transition-transform duration-300`}
          />
        </div>
      </div>

      {isOpen.massage && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition'}`}
        >
          {Object.keys(massages).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`massages.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`massages.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`massages.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* cryo Massage */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("cryoMassage")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceCryoMassage")}
          </h1>
          <p className="text-sm">{t("serviceCryoMassageType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.cryoMassage ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.cryoMassage && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(cryoMassage).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`cryoMassage.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`cryoMassage.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`cryoMassage.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Monthly member ship 
    <div className='p-4 shadow-md rounded-lg my-5 flex justify-between items-center' onClick={() => handleServices('monthlyMembership')}>
        <div>
          <h1 className='text-2xl mb-3 font-Merriweather'>{t('serviceMonthlyMembership')}</h1>
          <p className='text-sm'>{t('serviceMonthlymembershipType')}</p>
        </div>
        <div>
          <IoIosArrowDown className={`${isOpen.monthlyMembership ? 'rotate-180' : 'rotate-0'} transition-transform duration-300`}/>
        </div>
    </div>
    {isOpen.monthlyMembership && (
   <div className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
    {Object.keys(monthlyMembership).map((key, index) => (
            <div className="md:w-[30%] border p-5 rounded-md cursor-pointer" key={index}>
                    <h2 className="text-lg font-Merriweather mb-2">{t(`monthlyMembership.${key}.title`)}</h2>
                    <p className='text-xs md:text-sm text-gray-600'>{t(`monthlyMembership.${key}.description`)}</p>
                  <div className="flex justify-between">
                    <h4 className='mt-5 text-xl font-semibold'>{t(`monthlyMembership.${key}.cost`)}</h4>
                    <button className='p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md'><Link to='https://www.vagaro.com/artistryspanwellness/services' target="_blank">BOOK NOW</Link></button>
                  </div>
            </div>
    ))}
</div>
)} */}

      {/*  signaturefacial */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("signaturefacial")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceSignaturefacial")}
          </h1>
          <p className="text-sm">{t("serviceSignatureFacialType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.signaturefacial ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.signaturefacial && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(signaturefacial).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`signaturefacial.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`signaturefacial.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`signaturefacial.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/*  cryoSkinHealth */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("cryoSkinHealth")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("servicecryoSkinHealth")}
          </h1>
          <p className="text-sm">{t("serviceCryoSkinHealthType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.cryoSkinHealth ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.cryoSkinHealth && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(cryoSkinHealth).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`cryoSkinHealth.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`cryoSkinHealth.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`cryoSkinHealth.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/*  cryoFacial */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("cryoFacial")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceCryofacial")}
          </h1>
          <p className="text-sm">{t("serviceCryofacialType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.cryoFacial ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.cryoFacial && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(cryoFacial).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`cryoFacial.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`cryoFacial.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`cryoFacial.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/*  cryoslimming */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("cryoslimming")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceCryoslimming")}
          </h1>
          <p className="text-sm">{t("serviceCryoslimmingType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.cryoslimming ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.cryoslimming && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(cryoslimming).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`cryoslimming.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`cryoslimming.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {" "}
                  {t(`cryoslimming.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/*targeted Cryotherapy */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("targetedCryotherapy")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceTargetedTherapy")}
          </h1>
          <p className="text-sm">{t("serviceTargetedTherapyType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.targetedCryotherapy ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.targetedCryotherapy && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(targetedCryotherapy).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`targetedCryotherapy.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`targetedCryotherapy.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`targetedCryotherapy.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/*Eyelashes extension */}
      <div
        className="p-4 shadow-md rounded-lg my-5 flex justify-between items-center"
        onClick={() => handleServices("eyelashesExtension")}
      >
        <div>
          <h1 className="text-2xl mb-3 font-Merriweather">
            {t("serviceEyelashesExtension")}
          </h1>
          <p className="text-sm">{t("serviceEyelashesExtensionType")}</p>
        </div>
        <div>
          <IoIosArrowDown
            className={`${
              isOpen.eyelashesExtension ? "rotate-180" : "rotate-0"
            } transition-transform duration-300`}
          />
        </div>
      </div>
      {isOpen.eyelashesExtension && (
        <div
          className={`flex justify-center gap-5 gap-y-6 flex-wrap transition-all duration-300 ease-in-out ${
            isOpen
              ? "max-h-[2000px] opacity-100"
              : "max-h-0 opacity-0 overflow-hidden"
          }`}
        >
          {Object.keys(eyelashesExtension).map((key, index) => (
            <div
              className="md:w-[30%] border p-5 rounded-md cursor-pointer"
              key={index}
            >
              <h2 className="text-lg font-Merriweather mb-2">
                {t(`eyelashesExtension.${key}.title`)}
              </h2>
              <p className="text-xs md:text-sm text-gray-600">
                {t(`eyelashesExtension.${key}.description`)}
              </p>
              <div className="flex justify-between">
                <h4 className="mt-5 text-xl font-semibold">
                  {t(`eyelashesExtension.${key}.cost`)}
                </h4>
                <button className="p-2.5 text-xs bg-gray-900 text-white mt-5 rounded-md">
                  <Link
                    to="https://www.vagaro.com/artistryspanwellness/services"
                    target="_blank"
                  >
                    BOOK NOW
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PriceServices
